import { useSelector, useDispatch } from "react-redux";

const useManufacturingOrder = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.manufacturingOrder);

  const updateData = manufacturingOrder => {
    dispatch({ type: "CHANGE_DESING", manufacturingOrder });
  };

  const updatePiece = manufacturingOrder => {
    dispatch({ type: "UPDATE_PIECE_STATUS", manufacturingOrder });
  };

  const getOrderWithDesings = () => {
    return data.map(item => item.desingId).filter((value, index, self) => self.indexOf(value) === index);
  };

  return { manufacturingOrder: data, updateData, updatePiece, getOrderWithDesings };
};

export default useManufacturingOrder;
